import MaterialTable from 'material-table';
import MTLocalization from '../utils/MTLocalization';
import React, {useEffect, useState} from 'react';
import {Checkbox} from "@material-ui/core";
import axios from "../utils/axios";

const CommentList = ({productId}) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios.get(`/product/${productId}/comment`)
            .then(res => {
                const comments = res.data.data.slice(0, 5);
                setData(comments);
            })
            .catch(e => console.log(e))
            .finally(() => setLoading(false));
    }, []);

    return (
        <MaterialTable
            localization={MTLocalization}
            options={{toolbar: false, paging: false}}
            style={{margin: 0, boxShadow: 'none'}}
            columns={[{
                title: "Skrytý", field: "hidden", width: 40, render: d => (
                    <Checkbox
                        checked={d.hidden === true}
                        onChange={async(e) => {
                            try {
                                const newValue = e.target.checked;
                                await axios.patch(`/product/${productId}/comment/hidden`, {
                                    id: d.id,
                                    hidden: newValue
                                });

                                setData(p => {
                                    return p.map(i => {
                                        if(i.id === d.id)
                                            return {...i, hidden: newValue}

                                        return i;
                                    })
                                });
                            } catch (err) {
                                console.log('Chyba při ukládání. ' + err);
                            }
                        }}
                    >
                    </Checkbox>
                )},
                {title: "Počet likes", field: "likes", width: 40},
                {title: "Spoiler", field: "spoiler", width: 40},
                {title: "Hodnocení", field: "rating", width: 20},
                {title: "Text", field: "text"},
            ]}
            data={data}
            isLoading={loading}
        />
    );
};

export default CommentList;
